import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import { onlineReputationContent } from '../content';

const stepDetail = (step: (typeof onlineReputationContent.steps)[number]): string => {
  const blockLines = [...step.blocks, ...(step.aside ?? [])].map((block) => {
    if (block.callout) {
      return `${block.callout.label}: ${block.callout.text}`;
    }

    return [block.heading, block.text, ...(block.bullets ?? [])].filter(Boolean).join(' ');
  });

  return [`Step ${step.number}: ${step.title}`, step.intro, ...blockLines]
    .filter(Boolean)
    .join('\n');
};

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Overview',
    description:
      'Introduction to protecting your online reputation — why colleges, scholarship committees, and employers review applicants online, and being intentional about what is public.',
    detail: onlineReputationContent.header.description.join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: onlineReputationContent.stepsSection.title,
    description:
      'Eight steps for protecting your online reputation: Google yourself, review your accounts, decide private vs. public, manage tagged photos, clean up old posts, check your profile image and bio, build one public professional presence, and think before you post.',
    detail: onlineReputationContent.steps.map(stepDetail).join('\n\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: onlineReputationContent.tools.title,
    description: 'Backrs tools and resources to support protecting your online reputation.',
  });

  useRegisterAgentContext({
    kind: 'section',
    title: onlineReputationContent.whyItMatters.title,
    description:
      'Why online reputation matters — the positive signals (leadership, creativity, community involvement) and negative signals (poor judgment, disrespect, lack of professionalism) colleges and employers read from your online presence.',
    detail: [
      onlineReputationContent.whyItMatters.intro,
      ...onlineReputationContent.whyItMatters.signalGroups.map(
        (group) => `${group.title}: ${group.items.join(', ')}`,
      ),
      onlineReputationContent.whyItMatters.outro,
      `${onlineReputationContent.whyItMatters.bottomLine.title}: ${onlineReputationContent.whyItMatters.bottomLine.body}`,
    ].join('\n'),
  });
};
